/* eslint-disable no-magic-numbers */
import React from 'react';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage, useIntl } from '@futrli/localisation';

interface Props {
  isOpenForecastingDialog?: boolean;
  handleCloseDialog: () => void;
  onSubmit: () => void;
  name: string;
}

export const DeleteForecastDialog = ({ isOpenForecastingDialog, handleCloseDialog, onSubmit, name }: Props) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage({
        id: 'common.warning_deletion',
        defaultMessage: 'Warning: deletion is irreversible'
      })}
      onCancel={handleCloseDialog}
      open={!!isOpenForecastingDialog}
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={handleCloseDialog} destructive>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button buttonType="primary" onClick={onSubmit} destructive id="forecasting-delete-confirm">
            <FormattedMessage id="common.delete" defaultMessage="Delete" />
          </Button>
        }
        onSubmit={onSubmit}
      >
        <Typography fontSize="16px" mb={0}>
          <FormattedMessage
            id="predict.are_you_sure_delete"
            defaultMessage="Are you sure you want to delete {name}?"
            values={{ name }}
          />
        </Typography>
      </Form>
    </Dialog>
  );
};
